module.exports = __webpack_public_path__ + "img/switch_sheying.a1eb7000.png";